import Grid from '@/global/components/ui/Grid'
import { Empresa } from '@/service/api'
import { Divider, Switch } from '@mui/material'
import { FormField } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

export default function Justificativas() {
    const { watch, setValue } = useFormContext<Empresa>()
    const justificativa = watch('justificativaPadraoRegistro')

    const [exigirJustificativa, setExigirJustificativa] = useState(
        justificativa == undefined,
    )

    return (
        <section id="justificativas">
            <Divider
                sx={{
                    mt: 4,
                    mb: 3,
                    userSelect: 'none',
                }}
            >
                Justificativas
            </Divider>
            <Grid container spacing={2}>
                <Grid item xs={12} className="inline-flex items-center">
                    <Switch
                        checked={exigirJustificativa}
                        onChange={() =>
                            setExigirJustificativa(prev => {
                                if (!prev) {
                                    setValue(
                                        'justificativaPadraoRegistro',
                                        null,
                                    )
                                    return true
                                }
                                setValue(
                                    'justificativaPadraoRegistro',
                                    'Inserido manualmente',
                                )
                                return false
                            })
                        }
                    />
                    <label>Exigir justificativa ao incluir registros</label>
                    <IconeAjuda>
                        <p>
                            Quando habilitado, sempre que um registro manual for
                            inserido na digitação, uma justificativa será
                            exigida para a inserção do registro.
                        </p>
                        <br />
                        <p>
                            Quando desabilitado, a justificativa padrão será
                            utilizada.
                        </p>
                    </IconeAjuda>
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        name="justificativaPadraoRegistro"
                        label="Justificativa padrão"
                        rows={5}
                        multiline
                        disabled={exigirJustificativa}
                        max={190}
                    />
                </Grid>
            </Grid>
        </section>
    )
}
